module.exports = __webpack_public_path__ + "static/media/Organization_9.582958da.svg";